import { useSnackbar } from 'notistack';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { fetchAllAvailableApplicationForms, PUBLIC_fetchTomeasParametrics } from '../../../../lib/fetchers';
import AllAvailableApplications from '../AllAvailableApplications';

function SmartAllAvailableApplications(
  { redirectsOutsideShadow = false }: { redirectsOutsideShadow: boolean }
) {
  const [isLoading, setIsLoading] = React.useState<boolean>(true);
  const [applications, setApplications] = React.useState<any>([]);
  const [tomeas, setTomeas] = React.useState<any>([]);
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();

  document.title = t('Αιτήματα στο ΕΚΟΜΕ');

  const fetching = async () => {
    try {
      const [appl, tomeas] =
        await Promise.all([fetchAllAvailableApplicationForms(), PUBLIC_fetchTomeasParametrics()]);
      setApplications(appl.data);
      setTomeas(tomeas.map((x: any) => {
        return { ...x, label: t(x.label) };
      }));
    } catch (error) {
      console.error(error);

      enqueueSnackbar(t('Παρουσιάστηκε κάποιο σφάλμα'), { variant: 'error' });

    }
    setIsLoading(false);
  };

  React.useEffect(() => {
    fetching();
  }, []);

  return (<>
    <AllAvailableApplications
      redirectsOutsideShadow={redirectsOutsideShadow}
      tomeas={tomeas}
      isLoading={isLoading}
      applications={applications}
    />
  </>);
}

export default SmartAllAvailableApplications;